import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Step from 'SbsSuite/Presentation/Step';
import CreateUpdateStepConsumableDialog from 'Consumables/views/CreateUpdateStepConsumableDialog';
import CreateUpdateStepPortlet from 'StepUpdateCreate/Components/CreateUpdateStepPortlet';
import Theme from 'Theme';

export default function StepList(props) {
  const {
    location,
    sbs,
    steps,
    subSbssLoaded,
    onDeleteStep,
    onAddStepAfter,
    onEditStep,
    onLoadSubSbs,
    onAddToSchedule,
    onMoveStepUp,
    onClickDecision,
    duplicationMode,
    duplicationSelectedSteps,
    onDuplicationToggleSelectedStep,
    onSaveStep,
    onCancelStep,
    onOpenStepConsumableCreateDialog,
    openStepConsumableCreateDialogBool,
    onCloseStepConsumableCreateDialog,
    onSaveStepConsumableDialog,
    isLoadAll,
  } = props;
  const canStepMoveUp = (index) => {
    if (
      typeof index !== 'number' ||
      index <= 0 ||
      index >= steps.length ||
      !steps[index].id ||
      steps[index].stepType.type === 'Decision' ||
      !steps[Math.max(0, index - 1)].id ||
      steps[Math.max(0, index - 1)].stepType.type === 'Decision' ||
      (steps[Math.max(0, index - 2)].id &&
        steps[Math.max(0, index - 2)].stepType.type === 'Decision')
    ) {
      return false;
    }

    return true;
  };
  const canAddStepAfter = (index) => {
    if (
      typeof index !== 'number' ||
      index < 0 ||
      index >= steps.length ||
      !steps[index].id ||
      (index + 1 < steps.length && !steps[index + 1].id)
    ) {
      return false;
    }

    return true;
  };

  return steps.length > 0 ? (
    <>
      {openStepConsumableCreateDialogBool && (
        <CreateUpdateStepConsumableDialog
          onSave={onSaveStepConsumableDialog}
          onClose={onCloseStepConsumableCreateDialog}
        />
      )}
      {steps.map((step, index) => {
        return !step.id || location.query.editStepId === step.id ? (
          <Theme>
            <CreateUpdateStepPortlet
              key={step.id || index}
              sbs={sbs}
              stepId={step.id}
              onSave={(s) => onSaveStep(s, step.decision, index)}
              onCancel={() => onCancelStep(index)}
            />
          </Theme>
        ) : (
          <Step
            isLoadAll={isLoadAll}
            key={step.id}
            location={location}
            index={index}
            step={step}
            isSubSbsLoaded={subSbssLoaded[step.id]}
            onEditStep={!location.query.editStepId ? onEditStep : undefined}
            onDeleteStep={onDeleteStep}
            onAddStepAfter={canAddStepAfter(index) ? onAddStepAfter : undefined}
            onLoadSubSbs={onLoadSubSbs}
            onAddToSchedule={onAddToSchedule}
            onMoveStepUp={canStepMoveUp(index) ? onMoveStepUp : undefined}
            onMoveStepDown={canStepMoveUp(index + 1) ? onMoveStepUp : undefined}
            onClickDecision={onClickDecision}
            isDuplicationSelected={duplicationSelectedSteps.includes(step.id)}
            onDuplicationToggleSelectedStep={
              duplicationMode ? onDuplicationToggleSelectedStep : undefined
            }
            openStepConsumableCreateDialogBool={
              openStepConsumableCreateDialogBool
            }
            onCloseStepConsumableCreateDialog={
              onCloseStepConsumableCreateDialog
            }
            onOpenStepConsumableCreateDialog={onOpenStepConsumableCreateDialog}
          />
        );
      })}
    </>
  ) : (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <CircularProgress style={{margin: 8}} />
    </div>
  );
}

StepList.propTypes = {
  location: PropTypes.object.isRequired,
  sbs: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  subSbssLoaded: PropTypes.object,
  onEditStep: PropTypes.func,
  onDeleteStep: PropTypes.func,
  onAddStepAfter: PropTypes.func,
  onLoadSubSbs: PropTypes.func,
  onAddToSchedule: PropTypes.func,
  onMoveStepUp: PropTypes.func,
  onClickDecision: PropTypes.func,
  duplicationMode: PropTypes.bool,
  duplicationSelectedSteps: PropTypes.array,
  onDuplicationToggleSelectedStep: PropTypes.func,
  onSaveStep: PropTypes.func,
  onCancelStep: PropTypes.func,
  openStepConsumableCreateDialogBool: PropTypes.bool,
  onCloseStepConsumableCreateDialog: PropTypes.func,
  onSaveStepConsumableDialog: PropTypes.func,
  onOpenStepConsumableCreateDialog: PropTypes.func,
  isLoadAll: PropTypes.bool.isRequired,
};

StepList.defaultProps = {
  subSbssLoaded: false,
  onEditStep: undefined,
  onDeleteStep: undefined,
  onAddStepAfter: undefined,
  onLoadSubSbs: undefined,
  onMoveStepUp: undefined,
  onClickDecision: undefined,
  duplicationMode: false,
  duplicationSelectedSteps: [],
  onDuplicationToggleSelectedStep: undefined,
  onSaveStep: undefined,
  onCancelStep: undefined,
  openStepConsumableCreateDialogBool: false,
  onCloseStepConsumableCreateDialog: undefined,
  onSaveStepConsumableDialog: undefined,
  onOpenStepConsumableCreateDialog: undefined,
};
